import { RESHOP_NSU_KEY_NAME } from "../constants/keyNamesSessionStorage";

export const nsuValueHelper = () => {
  try {
    return JSON.parse(sessionStorage.getItem(RESHOP_NSU_KEY_NAME) || "") ?? ""
  } catch (error) {
    return "";
  }
};
